import { useRef } from 'react';
import { useRequest } from 'umi';
import { checkPinStaff } from '@/services/staff';
export default function useStaffModel(params: any) {
  const checkPin = useRef<string | null>(null); 

  const { loading, run } = useRequest(checkPinStaff, {
    cacheKey: 'term',
    manual: true,
    formatResult: (res) => res,
    onSuccess: (response) => {
      if (response && response.token) {
        checkPin.current = response.token;
      } else {
        checkPin.current = null;
      }
    },
    onError: () => {
      checkPin.current = null;
    }
  });

  return { checkPin, fetchCheckPinStaff: run, loading };
}
